import { Typography } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import Localize from '../../utils/string';

const OurServicesTop = () => {
    return (
        <Content className="our-services-top">
            <div className="container">
                <Typography.Title level={3}>{Localize.HomeOurServicesTitle}</Typography.Title>
                <Typography.Text>{Localize.HomeOurServicesDesc}</Typography.Text>
            </div>
        </Content>
    )
}

export default OurServicesTop;